/**
 * The MOE (720) question-type vocabulary — the closed list from the technical content spec
 * ("questionType", written per the xAPI standard but a SUBSET of it: no `long-fill-in` / `likert`).
 * This is distinct from {@link XApiActivityInteractionType} (the standard xAPI
 * `object.definition.interactionType`, left unchanged so OFEK statements don't regress): this
 * vocabulary is what a 720 report describes a question as — the value MOE stores in the metadata
 * `questions[].questionType` and matches an `answered` `result.response` against.
 *
 * A leaf on purpose: the widget schemas declare the `moeQuestionType` field from it, and the resolver that
 * reads a question's content imports those schemas, so the vocabulary cannot live beside the resolver.
 */
export const MOE_QUESTION_TYPES = [
  'fill-in',
  'true-false',
  'choice',
  'numeric',
  'sequencing',
  'matching',
  'performance',
  'other'
] as const;

export type MoeQuestionType = (typeof MOE_QUESTION_TYPES)[number];
